import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import moment from 'moment';

import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';

import DeleteIcon from '@material-ui/icons/Delete';
import ReceiptIcon from '@material-ui/icons/Receipt';

import backgroundColor from '@material-ui/core/colors/indigo';

import { editImportMaterial } from '../../../store/actions';

const styles = theme => ({
  title: {
    backgroundColor: backgroundColor[500],
  },
});

const ImportMaterials = (props) => {
  const {
    receipts,
    vendors,
    editImportMaterial,
  } = props;

  return(
      <Table>
        <TableHead>
          <TableRow>
            <TableCell padding="dense" variant="head">Type</TableCell>
            <TableCell padding="dense" variant="head">Date</TableCell>
            <TableCell padding="dense" variant="head">Vendor</TableCell>
            <TableCell padding="dense" variant="head">Amount</TableCell>
            <TableCell padding="dense" variant="head">Markup</TableCell>
            <TableCell padding="dense" variant="head">Charged</TableCell>
            <TableCell padding="dense" variant="head">Include</TableCell>
            <TableCell padding="none" variant="head" numeric />
          </TableRow>
        </TableHead>
        <TableBody>
          {receipts &&
            receipts.filter(receipt => !receipt.exclude).map(receipt => {
              const vendor = vendors.find(vendor => vendor.id === receipt.vendorId);

              return(
                <TableRow key={receipt.id}>
                  <TableCell padding="dense" variant="body">
                    <ReceiptIcon />
                  </TableCell>
                  <TableCell padding="dense" variant="body">
                    {moment(receipt.date).format("MMM Do, YYYY")}
                  </TableCell>
                  <TableCell padding="dense" variant="body">
                    {vendor && vendor.name}
                  </TableCell>
                  <TableCell padding="dense" variant="body">
                    {`$${receipt.total}`}
                  </TableCell>
                  <TableCell padding="dense" variant="body">
                    {`${receipt.markupPercent}%`}
                  </TableCell>
                  <TableCell padding="dense" variant="body">
                    {`$${receipt.charged}`}
                  </TableCell>

                  <TableCell padding="dense" variant="body">
                    <Checkbox
                      color="primary"
                      checked={receipt.include}
                      onChange={() => editImportMaterial(receipt.id, {include: !receipt.include})}
                    />
                  </TableCell>
                  <TableCell padding="none" variant="body" numeric>
                    <Button
                      aria-label="delete"
                      size="small"
                      onClick={() => editImportMaterial(receipt.id, { exclude: true, updated: true })}
                      style={{color: '#757de8'}}
                      >
                      <DeleteIcon />
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })
          }
        </TableBody>
      </Table>
  );
}

const mapStateToProps = (state) => ({
  receipts: state.formData.importTimeMaterials.receipts,
  vendors: state.vendorsState,
});

const mapDispatchToProps = {
  editImportMaterial,
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(ImportMaterials);



// WEBPACK FOOTER //
// ./src/components/admin/Invoice/ImportMaterials.jsx